import axios from 'axios';
import { getAuthToken, removeAuthToken } from '../utils/helpers';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Attach active business context if available
  const activeBusinessId = localStorage.getItem('activeBusinessId');
  if (activeBusinessId) {
    config.headers['x-business-id'] = activeBusinessId;
  }
  
  return config;
}, (error) => Promise.reject(error));

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      removeAuthToken();
      
      // Do not hard-redirect if we are already trying to login
      if (error.config && !error.config.url.includes('/auth/login')) {
        window.location.href = '/login';
      }
    }
    
    // Check for Subscription Limit Exceeded
    if (error.response?.status === 403 && error.response?.data?.upgradeRequired) {
      const detail = error.response.data;
      const event = new CustomEvent('showUpgradeModal', { detail });
      window.dispatchEvent(event);
    }
    
    return Promise.reject(error);
  }
);

export default api;
